/**
 * Check if object (array also) or string is empty
 */
export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

/**
 * Simple check for null or zero (different than empty because '0')
 */
export const isNullOrZero = val => !val || val === '0' || val === 0;

export const isEqualObject = (object, other) => {
  if (object === other) return true;
  if (!object || !other) return false;

  const objectKeys = Object.keys(object);
  const otherKeys = Object.keys(other);

  if (objectKeys.length !== otherKeys.length) return false;

  return objectKeys.every(key => {
    const val1 = object[key];
    const val2 = other[key];

    // Handle nested objects
    if (
      typeof val1 === 'object' &&
      val1 !== null &&
      typeof val2 === 'object' &&
      val2 !== null
    ) {
      return isEqualObject(val1, val2);
    }

    return val1 === val2;
  });
};

export const isEqualArray = (array, other) => {
  if (array === other) return true;
  if (!array || !other) return false;
  if (array.length !== other.length) return false;

  return array.every((item, index) => {
    const item1 = array[index];
    const item2 = other[index];

    // Handle nested arrays/objects
    if (
      typeof item1 === 'object' &&
      item1 !== null &&
      typeof item2 === 'object' &&
      item2 !== null
    ) {
      if (Array.isArray(item1) && Array.isArray(item2)) {
        return isEqualArray(item1, item2);
      } else {
        return isEqualObject(item1, item2);
      }
    }

    return item1 === item2;
  });
};

/* Check value is null or undefined */
export const isNil = value => value === null || value === undefined;

/* Check value is string */
export const isString = value => typeof value === 'string';

export const filterNullValueFromArray = array => {
  if (isEmpty(array)) return [];

  const newArray = Object.keys(array).reduce((acc, key) => {
    if (array[key]) {
      return [...acc, array[key]];
    }
    return acc;
  }, []);
  return newArray;
};

export const isJsonString = str => {
  if (!isNaN(str)) return false;

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
